import React, { useState } from "react";
import SideAndSearchbar from "../../Components/layouts/SideAndSearchbar";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify"; // Import toast components
import "react-toastify/dist/ReactToastify.css";

const SettingsList = () => {
  const [settings, setSettings] = useState({
    logo: "",
    favicon: "",
    paymentMethod: "",
    paymentApiKey: "",
  });

  const [image, setImage] = useState("");

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prevSettings) => ({ ...prevSettings, [name]: value }));
  };

  // Handle logo and favicon upload


  const handleFileChange = (e, type) => {
    const { files } = e.target;
    if (files.length > 0) {
      const file = files[0];

      // Create a new File object with the desired name
      const renamedFile = new File([file], `${type}-${file.name}`, {
        type: file.type,
      });

      // Store the renamed image temporarily in state
      setImage(renamedFile);
    }
  };

  // Handle form submission (save settings)
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Settings updated:", settings);
    // You can dispatch an action to save the settings here
    // dispatch(updateSettings(settings));
  };

  const handleCardSave = async (type) => {
    if (!image) {
      toast.error("No file selected! Please upload an image.");
      console.error("No file selected");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("image", image);

      const response = await axios.post(`/api/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Profile settings saved:", response.data);

      // Assuming the response contains the URL of the uploaded image
      const imageUrl = response.data.data.secure_url;

      // Update settings state with the new image URL
      setSettings((prevSettings) => ({
        ...prevSettings,
        [type]: imageUrl,
      }));

      // Reset the image state after successful upload
      setImage("");
      toast.success(
        `${type.charAt(0).toUpperCase() + type.slice(1)} saved successfully!`
      );
    } catch (error) {
      // Improved error handling
      if (error.response) {
        console.error("Error saving profile:", error.response.data);
        toast.error("Error saving profile: " + error.response.data); 
      } else if (error.request) {
        console.error(
          "No response received while saving profile:",
          error.request
        );
        toast.error("No response received while saving profile.");
      } else {
        console.error(
          "Error in setting up the request for profile:",
          error.message
        );
        toast.error(
          "Error in setting up the request for profile: " + error.message
        );
      }
    }
  };

  // original_filename;

  // Handle deselecting image
  const handleImageRemove = (type) => {
    setSettings((prevSettings) => ({ ...prevSettings, [type]: "" }));
  };

  return (
    <>
      <ToastContainer />
      <SideAndSearchbar />
      <div className="pcoded-main-container">
        <h2 className="my-4 text-center">Settings Page</h2>

        <form
          onSubmit={handleSubmit}
          className="mb-4"
          encType="multipart/form-data"
        >
          <div className="row justify-content-center">
            {/* Logo Upload Card */}
            <div className="col-md-5 mb-3 mx-2">
              <div className="card shadow-sm border-0">
                <div className="card-header bg-primary text-white">
                  <h5 className="mb-0">Upload Logo</h5>
                </div>
                <div className="card-body">
                  <label htmlFor="logo" className="form-label">
                    Logo
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    name="logo"
                    onChange={(e) => handleFileChange(e, "logo")}
                  />

                  {settings.logo && (
                    <div className="text-center mt-2 position-relative">
                      <img
                        src={settings.logo} 
                        alt="Logo Preview"
                        className="img-fluid rounded"
                        style={{ maxHeight: "100px", maxWidth: "100px" }}
                      />
                      <button
                        type="button"
                        className="btn btn-danger position-absolute top-0 end-0"
                        style={{
                          borderRadius: "50%",
                          padding: "0.2rem 0.4rem",
                          backgroundColor: "rgba(255, 255, 255, 0.7)",
                          backdropFilter: "blur(4px)",
                          border: "none",
                          color: "red",
                        }}
                        onClick={() => handleImageRemove("logo")}
                      >
                        &times;
                      </button>
                    </div>
                  )}
                  <div className="text-center mt-3">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => handleCardSave("logo")}
                    >
                      Save Logo
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Favicon Upload Card */}
            <div className="col-md-5 mb-3 mx-2">
              <div className="card shadow-sm border-0">
                <div className="card-header bg-warning text-white">
                  <h5 className="mb-0">Upload Favicon</h5>
                </div>
                <div className="card-body">
                  <label htmlFor="favicon" className="form-label">
                    Favicon
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    name="favicon"
                    onChange={(e) => handleFileChange(e, "favicon")}
                  />
                  {settings.favicon && (
                    <div className="text-center mt-2 position-relative">
                      <img
                        src={settings.favicon} // Use the URL from settings
                        alt="Favicon Preview"
                        className="img-fluid rounded"
                        style={{ maxHeight: "50px", maxWidth: "50px" }}
                      />
                      <button
                        type="button"
                        className="btn position-absolute top-0 end-0"
                        style={{
                          borderRadius: "50%",
                          padding: "0.2rem 0.4rem",
                          backgroundColor: "rgba(255, 255, 255, 0.7)",
                          backdropFilter: "blur(4px)",
                          border: "none",
                          color: "red",
                        }}
                        onClick={() => handleImageRemove("favicon")}
                      >
                        &times;
                      </button>
                    </div>
                  )}
                  <div className="text-center mt-3">
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={() => handleCardSave("favicon")}
                    >
                      Save Favicon
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            {/* Payment Method Card */}
            <div className="col-md-5 mb-3 mx-2">
              <div className="card shadow-sm border-0">
                <div className="card-header bg-success text-white">
                  <h5 className="mb-0">Payment Method</h5>
                </div>
                <div className="card-body">
                  <label htmlFor="paymentMethod" className="form-label">
                    Payment Method
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="paymentMethod"
                    value={settings.paymentMethod}
                    onChange={handleChange}
                    placeholder="Enter payment method"
                  />
                  <div className="text-center mt-3">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => handleCardSave("paymentMethod")}
                    >
                      Save Payment Method
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Payment API Key Card */}
            <div className="col-md-5 mb-3 mx-2">
              <div className="card shadow-sm border-0">
                <div className="card-header bg-danger text-white">
                  <h5 className="mb-0">Payment API Key</h5>
                </div>
                <div className="card-body">
                  <label htmlFor="paymentApiKey" className="form-label">
                    API Key
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="paymentApiKey"
                    value={settings.paymentApiKey}
                    onChange={handleChange}
                    placeholder="Enter payment API key"
                  />
                  <div className="text-center mt-3">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => handleCardSave("paymentApiKey")}
                    >
                      Save API Key
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default SettingsList;
